import React, {useEffect, useState} from "react";
import Spinner from "../../../spinner";
import {Button, Row, Col, Table} from "antd";
import {userServices} from "../../../../services";
import {CONSIGNOR_DIRECTOR_PERMISSION} from "../../../../helpers/user_permission.helper";
import {edoService} from "../../../../services/edo.services";
import ModalEdoShipperAuth from "../../../modals/edo-shipper-auth";

export default function EdoSettingsConsignor() {
  const [loading, setLoading] = useState(true);
  const [accountsData, setAccountsData] = useState([]);
  const [errorMsg, setErrorMsg] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [isNeedRefresh, setIsNeedRefresh] = useState(false);

  const user = userServices.getUser();

  useEffect(() => {
    edoService.getShipperAccounts()
      .then((response) => {
        setAccountsData(response.map((item) => ({
          key: item.id,
          type: item.type,
          username: item.username,
          priority: item.priority,
          consignor_name: item.consignor_name,
          shipper_company_name: item.shipper_company_name,
          isValid: item.isValid,
        })));
        setLoading(false);
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      });
  }, [isNeedRefresh]);

  const handleAuthClick = () => {
    setShowLogin(true);
  };

  if (errorMsg) {
    return <div className="content-error-block">{errorMsg}</div>;
  }

  if (!user.isAccessTo(CONSIGNOR_DIRECTOR_PERMISSION)) {
    return null;
  }

  const columns = [
    {
      title: "Грузовладелец",
      dataIndex: "consignor_name",
    },
    {
      title: "Компания",
      dataIndex: "shipper_company_name",
    },
    {
      title: "Тип",
      dataIndex: "type",
    },
    {
      title: "Пользователь",
      dataIndex: "username",
    },
    {
      title: "Приоритет",
      dataIndex: "priority",
    }
    /*{
      title: "Статус",
      dataIndex: "isValid",
      render: (isValid) => (
        <span style={{color: isValid ? '#1CAA53' : '#ff4d4f'}}>
          {isValid ? 'Активен' : 'Неактивен'}
        </span>
      ),
    },*/
  ];

  return (
    <React.Fragment>
      <Row style={{marginBottom: 16}}>
        <Col>
          <Button
            type="primary"
            icon="plus"
            style={{background: '#1CAA53', borderColor: '#1CAA53', borderRadius: 10}}
            onClick={handleAuthClick}
          >
            Авторизоваться
          </Button>
        </Col>
      </Row>
      <Spinner loading={loading} tip="Загрузка...">
        <Table
          style={{minWidth: "700px"}}
          columns={columns}
          dataSource={accountsData}
          locale={{emptyText: "Нет привязанных учетных записей ЭДО"}}
          size="small"
          pagination={{pageSize: 50}}
          className="car-park"
          rowClassName={() => "car-park-row"}
        />
      </Spinner>
      <ModalEdoShipperAuth
        isShow={showLogin}
        setIsShow={setShowLogin}
        setIsNeedUpdate={() => setIsNeedRefresh(prev => !prev)}
      />
    </React.Fragment>
  );
}
